import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ISubscriptionManagerProps } from "entity/SubscriptionManager/SubscriptionManager";

const SubscriptionManager = lazyLoadComponent(() => import("./SubscriptionManager"));

interface ISubscriptionManagerRouteProps
    extends Omit<
        ISubscriptionManagerProps,
        "fromSettings" | "fromFrozenBuilder" | "history" | "location" | "match"
    > {
    fromUpgrade?: boolean;
}

export const RouteSubscriptionManager = (props: ISubscriptionManagerRouteProps) => (
    <RouteRelative
        path={routes.subscriptionManager.settings}
        render={(routeProps) => {
            const { fromSettings: fromSettingsParam, fromFrozenBuilder: fromFrozenBuilderParam } =
                routeProps.match.params as { fromSettings: string; fromFrozenBuilder: string };
            const fromSettings = fromSettingsParam === "true";
            const fromFrozenBuilder = fromFrozenBuilderParam === "true";

            const searchParams = new URLSearchParams(routeProps.location.search);
            const fromBuilderSetup = searchParams.get("fromBuilderSetup") === "true";

            const modalConfig =
                fromBuilderSetup && props.modalConfig
                    ? {
                          ...props.modalConfig,
                          beforeClose: () => routeProps.history.push(routes.builderSetup.setup),
                      }
                    : props.modalConfig;

            return (
                <SubscriptionManager
                    {...props}
                    {...routeProps}
                    modalConfig={modalConfig}
                    fromSettings={fromSettings}
                    fromFrozenBuilder={fromFrozenBuilder}
                    fromUpgrade={props.fromUpgrade}
                />
            );
        }}
    />
);
